export default class MessageContent {

  private readonly _value: string;

  constructor(value: string) {
    this._value = value;
  }

  public isEqualTo(other: MessageContent): boolean {
    return this.value === other?.value;
  }

  public get value(): string {
    return this._value;
  }

  public static get Prototype(): MessageContent {
    return new MessageContent("");
  }

  public fromJSON(value: string): MessageContent {
    return new MessageContent(value);
  }
  public toJSON(): string {
    return this.value;
  }
  public clone(): MessageContent {
    return new MessageContent(this.value);
  }
}
